(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2838],{

/***/ 82101:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/soc",
      function () {
        return __webpack_require__(7134);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ CalComModalTrigger; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _calcom_embed_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98254);
/* harmony import */ var react_icons_rx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55788);




const CalComModal = (param)=>{
    let { close =()=>{} , calLink ="boloforms/signature"  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (async function() {
            const Cal = await (0,_calcom_embed_react__WEBPACK_IMPORTED_MODULE_2__/* .getCalApi */ .o)();
            Cal("ui", {
                theme: "dark",
                hideEventTypeDetails: false
            });
        })();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "fixed top-0 left-0 z-[99999] w-screen h-screen backdrop-blur-md grid place-items-center p-8",
        onClick: close,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full max-w-screen-lg mx-auto relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "z-10 absolute top-0 md:top-6 -right-4 p-2 rounded-full bg-gray-300",
                    onClick: close,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_rx__WEBPACK_IMPORTED_MODULE_3__/* .RxCross2 */ .$iT, {
                        className: "text-2xl text-white"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_calcom_embed_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                // calLink="boloforms/signature"
                calLink: calLink,
                style: {
                    height: "100%",
                    width: "100%"
                },
                className: "max-w-[calc(100wv-20px)] w-full h-full max-h-[calc(100vh-100px)] overflow-y-auto",
                onClick: (e)=>e.stopPropagation()
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CalComModal);
const CalComModalTrigger = (param)=>{
    let { children , calLink  } = param;
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CalComModal, {
                close: ()=>setShowModal(false),
                calLink: calLink
            }),
            /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, {
                onClick: ()=>setShowModal(true)
            })
        ]
    });
};


/***/ }),

/***/ 7134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63750);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60155);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89583);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70231);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5434);
/* harmony import */ var react_icons_gi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2585);
/* harmony import */ var react_icons_tb__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37106);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47516);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69274);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43138);
/* harmony import */ var _components_Modal_CalComModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65421);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);



















const TSC = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_8__/* .IoShieldCheckmark */ .OYx, {
            className: "w-8 h-8"
        }),
        title: "Security",
        description: "The protection of system resources against unauthorized access.",
        bgColor: "bg-accent-green"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_9__/* .FaDatabase */ .i1q, {
            className: "w-8 h-8"
        }),
        title: "Availability",
        description: "Ensuring systems and information are available for operation and use as committed or agreed.",
        bgColor: "bg-accent-orange"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_8__/* .IoCheckmarkDoneSharp */ .kme, {
            className: "w-8 h-8"
        }),
        title: "Processing Integrity",
        description: "System processing is complete, valid, accurate, timely and authorized.",
        bgColor: "bg-accent-pink"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_10__/* .BsIncognito */ .C5e, {
            className: "w-8 h-8"
        }),
        title: "Confidentiality",
        description: "Information designated as confidential protected as committed or agreed.",
        bgColor: "bg-primary/30"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_11__/* .FaLock */ .kUi, {
            className: "w-8 h-8"
        }),
        title: "Privacy",
        description: "Personal information is collected, used, retained, disclosed and disposed of in conformity with the commitments in the entity's privacy notice.",
        bgColor: "bg-accent-blue"
    }
];
const complianceRequirements = [
    {
        title: "Custom Security Measures",
        description: "Tailor security protocols to fit specific business needs, far exceeding general cloud security standards.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdDashboardCustomize */ .dHZ, {
            className: "w-10 h-10 stroke-1"
        }),
        bgColor: "bg-accent-green"
    },
    {
        title: "Direct Control Over Data Access",
        description: "Manage who accesses your data and when, with no intermediary.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_gi__WEBPACK_IMPORTED_MODULE_13__/* .GiSettingsKnobs */ .gbl, {
            className: "w-10 h-10 stroke-1"
        }),
        bgColor: "bg-accent-orange"
    },
    {
        title: "Enhanced Audit Capability",
        description: "Maintain comprehensive logs and audit trails that are readily accessible and detailed, exceeding SOC 2 requirements for monitoring and logging.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb__WEBPACK_IMPORTED_MODULE_14__/* .TbRouteSquare */ .X8H, {
            className: "w-10 h-10 stroke-1"
        }),
        bgColor: "bg-accent-pink"
    },
    {
        title: "Access Controls",
        description: "You can enforce role-based access control and multi-factor authentication.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_15__/* .BiFingerprint */ .DKo, {
            className: "w-10 h-10 stroke-1"
        }),
        bgColor: "bg-accent-blue"
    }
];
const SOC = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "space-y-6 sm:space-y-16 max-w-screen-xl mx-auto mb-10 md:mt-20 mt-8 md:px-8 px-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "SOC 2 compliant eSignature | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Electronic signatures refer to signatures in digital format, distinguishing them from traditional handwritten signatures. These digital signatures hold full legal validity for indicating consent or endorsement of document contents. The prevalence of eSignatures is progressively supplanting manual signatures, serving as a versatile method to sign a wide array of documents spanning various sectors on a global scale."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "eSignature, electronic signature, digital signature, eSign, eSignatures, electronic signatures, digital signatures, eSignature software, electronic signature software, digital signature software, eSignature solution, electronic signature solution, digital signature solution, eSignature app, electronic signature app, digital signature app, eSignature platform, electronic signature platform, digital signature platform, eSignature service, electronic signature service, digital signature service, eSignature tool, electronic signature tool, digital signature tool, eSignature online, electronic signature online, digital signature online, eSignature solution online, electronic signature solution online, digital signature solution online, eSignature software online, electronic signature software online, digital signature software online, eSignature platform online, electronic signature platform online, digital signature platform online"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/soc/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "SOC 2 compliant eSignature | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/soc/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "SOC 2 compliant eSignature | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/soc/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-bold text-4xl sm:text-5xl",
                        children: "SOC 2 compliant eSignature"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl sm:text-xl max-w-screen-lg",
                        children: "SOC 2 is a set of criteria developed by the American Institute of Certified Public Accountants (AICPA) specifically for managing customer data based on five 'trust service principles'. This framework is applicable to any service provider storing customer data in the cloud, emphasizing not just physical security but also operational and procedural safeguards."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "space-y-8 max-w-screen-md",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-bold text-3xl sm:text-4xl",
                        children: "Importance of SOC 2 for Service Organizations"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl sm:text-xl max-w-screen-xl",
                        children: "Adhering to SOC 2 standards is imperative for ensuring that systems are set up to assure security, availability, processing integrity, confidentiality and privacy of customer data. Compliance demonstrates a company's commitment to data protection and operational excellence, essential for maintaining customer trust and competitive advantage."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "divide-y-2 divide-base-300",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-16 py-8 md:py-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "space-y-8 md:space-y-0 md:flex md:items-start md:space-x-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-52 h-52 relative flex-shrink-0 flex justify-center items-center bg-gradient-to-t from-neutral-200 to-neutral-100 p-8 rounded-xl ring-2 ring-neutral-500 shadow-xl",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSETS_URL, "/v2/security/soc1.png"),
                                                alt: "soc_logo",
                                                width: 200,
                                                height: 200
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "font-bold text-3xl sm:text-4xl",
                                                    children: "Types of SOC 2 Reports"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    className: "text-xl xl:leading-8 mt-4 space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: "flex space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_10__/* .BsCheckCircleFill */ .N9r, {
                                                                    className: "w-6 h-6 shrink-0 mt-1"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "font-bold",
                                                                            children: "Type I Report "
                                                                        }),
                                                                        " ",
                                                                        "evaluates the design of security processes at a specific point in time."
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: "flex space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_10__/* .BsCheckCircleFill */ .N9r, {
                                                                    className: "w-6 h-6 shrink-0 mt-1"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "font-bold",
                                                                            children: "Type II Report"
                                                                        }),
                                                                        " assesses how effective those security processes are over a period, typically six months or more providing a more comprehensive validation of compliance."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-bold text-3xl sm:text-4xl mb-8",
                                            children: "Understanding the Trust Service Criteria"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3",
                                            children: TSC.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "py-6 px-8 space-y-3 border border-surface-dark rounded-xl transition-all duration-500 ease-in-out bg-surface-light",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-center space-x-2",
                                                            children: [
                                                                item.icon,
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "text-xl font-semibold",
                                                                    children: item.title
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: item.description
                                                        })
                                                    ]
                                                }, index))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: " max-w-4xl text-xl xl:leading-8 mt-8",
                                            children: [
                                                "For detailed guidelines and the official framework, visit",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    className: "underline",
                                                    href: "https://www.aicpa-cima.com/",
                                                    target: "_blank",
                                                    children: "AICPA's SOC 2"
                                                }),
                                                " ",
                                                "details."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "space-y-16 py-8 md:py-20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "font-bold text-3xl sm:text-4xl mb-8 max-w-2xl",
                                        children: "The Necessity of SOC 2 Compliance for eSignature Solutions"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-2xl font-bold mb-4",
                                        children: "Data Security Challenges in eSignatures"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "max-w-4xl text-xl xl:leading-8 mb-8",
                                        children: "eSignature technology involves the storage and management of highly sensitive data, such as personal identifiers and contractual documents. SOC 2 compliance ensures that these data handling processes are secure and that integrity and confidentiality are maintained."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-2xl font-bold mb-4",
                                        children: "Enhanced Trust with SOC 2 Compliant eSignatures"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "max-w-4xl text-xl xl:leading-8",
                                        children: "Businesses leveraging eSignature technology are often subject to scrutiny regarding data security. By implementing a SOC 2 compliant solution, companies can assure clients and partners of their data's safety, significantly enhancing trust and reliability."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "space-y-16 py-8 md:py-20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mb-8",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-bold text-3xl sm:text-4xl max-w-screen-xlg",
                                                children: "How does BoloSign support your SOC 2 compliance requirements?"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-xl xl:leading-8 mt-4",
                                                children: "BoloSign's on-premises solution ensures that you retain full control over your data while meeting the stringent requirements of SOC 2 compliance."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "grid grid-cols-1 gap-8 md:grid-cols-2",
                                        children: complianceRequirements.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "py-6 px-8 space-y-3 border border-surface-dark  rounded-xl transition-all duration-500 ease-in-out bg-surface-light",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center space-x-4",
                                                        children: [
                                                            item.icon,
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-2xl font-semibold",
                                                                children: item.title
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: item.description
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-surface rounded-3xl px-6 py-8 md:px-12 md:py-12 border border-surface-dark",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:items-center md:space-x-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mx-auto md:mx-0 md:text-left md:w-2/3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "font-bold text-3xl sm:text-4xl mb-5",
                                        children: "How do you enable SOC 2 Compliance in your BoloSign account?"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "max-w-4xl text-xl lg:leading-8 text-neutral-600",
                                        children: "If you're interested in discussing how BoloSign can accommodate your SOC 2 compliance, feel free to reach out to our sales team."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-8 md:mt-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Modal_CalComModal__WEBPACK_IMPORTED_MODULE_6__/* .CalComModalTrigger */ .h, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary1 */ .au, {
                                        buttonText: "Talk to Sales",
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_16__/* .HiArrowLongRight */ .P8b, {})
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SOC);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,1057,4980,8907,8254,9774,2888,179], function() { return __webpack_exec__(82101); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);